{"id":"ProductDetail.Info.Tags","prefabs":{"default":{"children":[{"component":"ProductDetail.Info.Tags","options":"options:*"}]}}}